<template>
  <div class="home">
    <img src="../assets/logo.png" />
    <img
      src="@/assets/images/Vonex2colours.png"
      alt="Vuetify.js"
      class="mb-5"
    />
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
};
</script>
